var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { gridWidth, GUTTER } from '../../utilities/grid';
import { fromSize } from '../../utilities/media';
export var LayoutDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  ", " {\n    ", "\n    max-width: ", "px;\n  }\n"], ["\n  width: 100%;\n\n  ", " {\n    ", "\n    max-width: ", "px;\n  }\n"])), fromSize('md'), function (_a) {
  var paddingTop = _a.paddingTop;
  return paddingTop ? "padding-top:".concat(parseInt(String(paddingTop)), "px;") : '';
}, function (_a) {
  var width = _a.width;
  return gridWidth['tablet'](parseInt(String(width)));
});
export var RowWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex: 1 1 1;\n  flex-direction: column;\n\n  & > *:not(:first-child) {\n    margin: ", "px 0 0 0;\n  }\n\n  ", " {\n    ", "\n  }\n"], ["\n  display: flex;\n  flex: 1 1 1;\n  flex-direction: column;\n\n  & > *:not(:first-child) {\n    margin: ", "px 0 0 0;\n  }\n\n  ", " {\n    ", "\n  }\n"])), GUTTER.mobile, fromSize('md'), function (_a) {
  var mode = _a.mode,
    gutter = _a.gutter,
    alignment = _a.alignment;
  if (mode === 'grid') {
    var justifyContent = 'center';
    if (alignment === 'left') {
      justifyContent = 'flex-start';
    } else if (alignment === 'right') {
      justifyContent = 'flex-end';
    }
    return "\n          flex-direction: row;\n          align-items: flex-start;\n          justify-content: ".concat(justifyContent, ";\n\n          & > *:not(:first-child) {\n            margin: 0;\n          }\n\n          margin-left: -").concat(Number(gutter) / 2, "px;\n          margin-right: -").concat(Number(gutter) / 2, "px;\n\n          & > * {\n            padding: 0 ").concat(Number(gutter) / 2, "px;\n          }\n        ");
  } else {
    var alignItems = 'flex-start';
    if (alignment === 'right') {
      alignItems = 'flex-end';
    } else if (alignment === 'center') {
      alignItems = 'center';
    }
    return "\n          flex-direction: column;\n          align-items: ".concat(alignItems, ";\n          & > *:not(:first-child) {\n            margin: ").concat(gutter, "px 0 0 0;\n          }\n        ");
  }
});
var templateObject_1, templateObject_2;